<script>
    Date.prototype.toFormatString = function (format) {
        const year = this.getFullYear()
        const month = this.getMonth() + 1
        const month2 = ("0" + month).slice(-2)
        const day2 = ("0" + this.getDate()).slice(-2)
        const hour2 = ("0" + this.getHours()).slice(-2)
        const minute2 = ("0" + this.getMinutes()).slice(-2)
        const second2 = ("0" + this.getSeconds()).slice(-2)

        const formattedValue = format.replace("yyyy", year).replace("MM", month2).replace("dd", day2).replace("HH", hour2).replace("mm", minute2).replace("ss", second2)

        return formattedValue
    }
    Date.prototype.addDay = function (v) {
        this.setDate(this.getDate()+v)
        return this
    }
    Date.prototype.diffMonth = function (d) {
        return (this.getFullYear() * 12 + this.getMonth()) - (d.getFullYear() * 12 + d.getMonth())
    }

    import {Line} from  'vue-chartjs'
    import db from '@/firebase/firestore.js'

    export default {
        extends: Line,
        props: {
            /**
             * 表示対象のユーザー
             */
            userUID: null,
            /**
             * このチャートの親要素
             */
            container: null,
            /**
             * 表示条件
             */
            condition: {
                type: Object,
                default: function () {
                    return {
                        /** 表示範囲("month"-月,"day"-1日) */
                        range: "month",
                        /** 年(表示範囲="月"の時に有効) */
                        year: 2020,
                        /** 月(表示範囲="月"の時に有効) */
                        month: 8,
                        /** 日付(表示範囲="日"の時に有効) */
                        date: "",
                        /** 日付(開始)(表示範囲="日範囲"の時に有効) */
                        dateFrom: "",
                        /** 日付(終了)(表示範囲="日範囲"の時に有効) */
                        dateTo: ""
                    }
                }
            },
            /**
             * 対象の場所
             */
            place: null,
            /**
             * 登録されている全作業種類
             */
            workTypes: null,
            /**
             * 登録されている全測定項目
             */
            measureItems: null,
            /**
             * 選択されている測定項目
             */
            selectedMeasureItem: null
        },
        data () {
            return {
                data: {
                    datasets: [
                        // {
                        //     label: 'Line Dataset',
                        //     data: [{x: "2020-08-01", y:1.5}, {x: "2020-08-10", y:1.5}],
                        //     borderColor: '#CFD8DC',
                        //     fill: false,
                        //     type: 'line',
                        //     lineTension: 0.0,
                        //     borderWidth: 5
                        // },
                        // {
                        //     label: 'Line Dataset',
                        //     data: [{x: "2020-08-21", y:1.5}, {x: "2020-08-31", y:1.5}],
                        //     borderColor: '#CFD8DC',
                        //     fill: false,
                        //     type: 'bar',
                        //     lineTension: 0.0,
                        //     borderWidth: 5
                        // },
                    ]
                },
                options: {
                    animation: {
                        duration: 0
                    },
                    maintainAspectRatio: false,
                    // animation: {
                    //     duration: 0
                    // },
                    legend: {
                        display: false
                    },
                    tooltips: {
                        enabled: true,
                        titleFontSize: 9,
                        backgroundColor: "rgba(255,255,0,0)",
                        titleFontColor: "rgba(0,0,0,1)"
                    },
                    scales: {
                        yAxes: [
                            {
                                id: "y-1",
                                scaleLabel: {
                                    display: false,
                                },
                                ticks: {
                                    beginAtZero: true,
                                    padding: 5,
                                    fontSize: 9
                                },
                                gridLines: {
                                    tickMarkLength: 0,
                                    color: "rgba(0,0,255,0.4)",
                                    borderDash: [2, 1]
                                },
                                position: "left"
                            },
                            {
                                id: "y-2",
                                scaleLabel: {
                                    display: false,
                                },
                                ticks: {
                                    beginAtZero: true,
                                    padding: 5,
                                    fontSize: 9
                                },
                                gridLines: {
                                    tickMarkLength: 0,
                                    color: "rgba(0,192,0,0.8)",
                                    borderDash: [2, 1]
                                },
                                position: "right"
                            }
                        ],
                        xAxes: [
                            {
                                scaleLabel: {
                                    display: false,
                                    labelString: '日'
                                },
                                type: "time",
                                time: {
                                    unit: "day",
                                },
                                gridLines: {
                                    tickMarkLength: 0
                                },
                                ticks: {
                                    fontSize: 9,
                                    maxRotation: 0,
                                    autoSkip: false,
                                    source: "date",
                                    padding: 5,
                                    min: "2020-08-01",
                                    max: "2020-08-31",
                                }
                            }
                        ]
                    }
                },
            }
        },
        watch: {
            /**
             * 変更監視:表示条件
             */
            condition: {
                handler: function (value, old) {
                    console.log("ChartEnvironment", "condition changed")
                    this.refresh()
                },
                deep: true
            },
            /**
             * 変更監視:場所が持つ全作業
             */
            place: {
                handler: function (value, old) {
                    console.log("ChartEnvironment", "place changed")
                    this.refresh()
                },
                deep: true
            },
            /**
             * 変更監視:全測定項目
             */
            measureItems: {
                handler: function (value, old) {
                    console.log("ChartEnvironment", "measureItems changed")
                    this.refresh()
                },
                deep: true
            },
            /**
             * 変更監視:選択されている測定項目
             */
            selectedMeasureItem: function (value, old) {
                console.log("ChartEnvironment", "selectedMeasureItem changed")
                this.refresh()
            }
        },
        created: function () {
        },
        mounted: function () {
            const self = this

            /**
             * Chartjs に作業のツールチップを常時表示するようプラグインを追加
             */
            this.addPlugin (
                {
                    beforeRender: function (chart) {
                        chart.pluginTooltips = []
                        chart.config.data.datasets.forEach(function (dataset, i) {
                            if (dataset.additionalData != null && dataset.additionalData.type == "work_dataset") {
                                chart.getDatasetMeta(i).data.forEach (function (sector, j) {
                                    if (dataset.data[sector._index].additionalData != null && dataset.data[sector._index].additionalData.type == "work") {
                                        chart.pluginTooltips.push (
                                            new Chart.Tooltip (
                                                {
                                                    _chart: chart.chart,
                                                    _chartInstance: chart,
                                                    _data: chart.data,
                                                    _options: chart.options.tooltips,
                                                    _active: [sector]
                                                },
                                                chart
                                            )
                                        )
                                    }
                                })
                            }
                        })
                    },
                    afterDraw: function (chart, easing) {
                        Chart.helpers.each(chart.pluginTooltips, function (tooltip) {
                            tooltip.initialize()
                            tooltip.update()
                            tooltip.transition(easing).draw()
                        })
                    }
                }
            )

            console.log("ChartEnvironment", "mounted")
            this.refresh()
        },
        methods: {
            /**
             * チャート更新
             */
            refresh: async function () {

                // console.log("======================= chart refresh start!!")
                // console.log("view range",this.condition.range)

                const self = this
                const lastDate = new Date(this.condition.year, this.condition.month, 0)

                /**
                 * 表示=日範囲で From>=To の時は値を入れ替える
                 */
                if (this.condition.range == "day_range" && this.condition.dateFrom > this.condition.dateTo) {
                    const w = this.condition.dateFrom
                    this.condition.dateFrom = this.condition.dateTo
                    this.condition.dateTo = w
                }

                /**
                 * X軸設定
                 */
                switch (this.condition.range) {
                    case "month":
                        this.options.scales.xAxes[0].ticks.min = this.condition.year + "-" + this.condition.month + "-01 00:00"
                        this.options.scales.xAxes[0].ticks.max = this.condition.year + "-" + this.condition.month + "-" + lastDate.getDate() + " 23:59"
                        this.options.scales.xAxes[0].time.unit = "day"
                        this.options.scales.xAxes[0].time.stepSize = 1
                        break;
                    case "day":
                        const xDate = new Date(this.condition.date)
                        this.options.scales.xAxes[0].ticks.min = xDate.toFormatString("yyyy-MM-dd 00:00")
                        this.options.scales.xAxes[0].ticks.max = xDate.toFormatString("yyyy-MM-dd 24:00")
                        this.options.scales.xAxes[0].time.unit = "minute"
                        this.options.scales.xAxes[0].time.stepSize = 60
                        break;
                    case "day_range":
                        const xDateFrom = new Date(this.condition.dateFrom)
                        const xDateTo = new Date(this.condition.dateTo)
                        this.options.scales.xAxes[0].ticks.min = xDateFrom.toFormatString("yyyy-MM-dd 00:00")
                        this.options.scales.xAxes[0].ticks.max = xDateTo.toFormatString("yyyy-MM-dd 24:00")
                        this.options.scales.xAxes[0].time.unit = "hour"
                        this.options.scales.xAxes[0].time.stepSize = 12
                        break;
                }
                // console.log("options(x axis)", this.options.scales.xAxes[0])

                this.options.scales.xAxes[0].ticks.callback = function (value, index,values) {
                    /**
                     * X軸のラベル描画
                     */
                    const d = new Date(values[index].value)
                    switch (self.condition.range) {
                        case "month":
                            if (d.getDate() == 1) {
                                return (d.getMonth()+1) + "/1"
                            } else {
                                if (self.$vuetify.breakpoint.xs) {
                                    if (d.getDate() % 2 == 0) {
                                        return d.getDate()
                                    } else {
                                        return ""
                                    }
                                } else {
                                    return d.getDate()
                                }
                            }
                            break;
                        case "day":
                            // return d.toFormatString("HH:mm")
                            if (self.$vuetify.breakpoint.xs) {
                                const hour = d.getHours()
                                if (hour == 0 || hour == 3 || hour == 6 || hour == 9 || hour == 12 || hour == 15 || hour == 18 || hour == 21) {
                                    return d.toFormatString("HH:mm")
                                } else {
                                    return ""
                                }
                            } else {
                                return d.toFormatString("HH:mm")
                            }
                        case "day_range":
                            if (index == 0 || d.getHours() == 0) {
                                return (d.getMonth()+1) + "/" + d.getDate()
                            } else {
                                return d.getHours() + ":00"
                            }
                            break;
                    }
                }

                /**
                 * Y軸設定
                 */
                var y1min = 999999
                var y1max = -999999
                var y2min = 999999
                var y2max = -999999
                
                for (var i=0; i<this.measureItems.length; i++) {
                    const item = this.measureItems[i]
                    switch (item.viewAxis) {
                        case 1:
                            if (item.body.min < y1min) y1min = item.body.min
                            if (item.body.max > y1max) y1max = item.body.max
                            break;
                        case 2:
                            if (item.body.min < y2min) y2min = item.body.min
                            if (item.body.max > y2max) y2max = item.body.max
                            break;
                    }
                    // console.log(item.body.min, item.body.max)
                }
                if (y1min == 999999) y1min = 0
                if (y1max == -999999) y1max = 1
                if (y2min == 999999) y2min = 0
                if (y2max == -999999) y2max = 1
                
                this.options.scales.yAxes[0].ticks.min = y1min
                this.options.scales.yAxes[0].ticks.max = y1max
                this.options.scales.yAxes[0].ticks.stepSize = 1 // y1max / 5
                this.options.scales.yAxes[1].ticks.min = y2min
                this.options.scales.yAxes[1].ticks.max = y2max
                this.options.scales.yAxes[1].ticks.stepSize = 1 // y2max / 5
                // console.log("ymin, max", y1min, y1max, y2min, y2max)
                // this.options.scales.yAxes[0].ticks.callback = function (value, index, values) {
                //     switch (value) {
                //         case 0: return "最小"
                //         case 1: return "最大"
                //         case 0.5: return "中間"
                //     }
                //     return ""
                // }

                /**
                 * オプション設定
                 */
                this.options.tooltips.callbacks = {
                    /**
                     * ツールチップのタイトル表示
                     */
                    title: function (tooltipItem, chart) {
                        // console.log(tooltipItem, chart)
                        const dataset = chart.datasets[tooltipItem[0].datasetIndex]
                        if (dataset.additionalData == null) {
                            return ""
                        }
                        switch (dataset.additionalData.type) {
                            case "measure_dataset":
                                const measureDatasetAdditionalData = dataset.additionalData
                                const measureValueAdditionalData = dataset.data[tooltipItem[0].index].additionalData
                                return measureDatasetAdditionalData.measureItem.body.name + 
                                       "(" + measureValueAdditionalData.min + "～" + measureValueAdditionalData.max + ")\n" + measureValueAdditionalData.dateTime + 
                                       " >> " + 
                                       measureValueAdditionalData.value + measureDatasetAdditionalData.measureItem.body.unit
                            case "work_dataset":
                                const workDatasetAdditionalData = dataset.additionalData
                                const workValueAdditionalData = dataset.data[tooltipItem[0].index].additionalData
                                switch (workValueAdditionalData.type) {
                                    case "work":
                                        var text = ""
                                        for (var i=0; i<workValueAdditionalData.works.length; i++) {
                                            const work = workValueAdditionalData.works[i]
                                            text += ((text == "" ? "" : "\n") + work.name)
                                        }
                                        return text
                                }
                        }
                        return "unknown"
                    },
                    /**
                     * ツールチップのラベル(非表示にする)
                     */
                    label: function (tooltipItem, chart) {
                    },
                }
                // this.options.showAllTooltips = true

                /**
                 * データセット
                 */
                /**
                 * 測定データをデータセットにセットするファンクション
                 */
                const measureValueSetter = function (dataset, measureItem) {
                    var dailyHistories = null
                    var dayHistory = null
                    switch (self.condition.range) {
                        case "month":
                            /** 表示範囲=月 */
                            dailyHistories = measureItem.histories[self.condition.year + "-" + ("0" + self.condition.month).slice(-2)]
                            for (var day=1; day<=lastDate.getDate(); day++) {
                                dayHistory = dailyHistories[day]
                                if (dayHistory != null) {
                                    // 全データ
                                    // for (var i=0; i<dayHistory.values.length; i++) {
                                    //     const value = dayHistory.values[i]
                                    //     const x = dayHistory.date + " " + value.time
                                    //     const y = (value.value - measureItem.body.min) / (measureItem.body.max - measureItem.body.min)
                                    //     // console.log(x, y, value.value, measureItem.body.min, measureItem.body.max)
                                    //     dataset.data.push(
                                    //         {
                                    //             x: x,
                                    //             y: y,
                                    //             additionalData: {
                                    //                 dateTime: x,
                                    //                 value: value.value,
                                    //                 min: measureItem.body.min,
                                    //                 max: measureItem.body.max
                                    //             }
                                    //         }
                                    //     )
                                    // }
                                    // 平均
                                    // var sum = 0
                                    // var num = 0
                                    // for (var i=0; i<dayHistory.values.length; i++) {
                                    //     sum+=dayHistory.values[i].value
                                    //     num++
                                    // }
                                    // const ave = sum / num
                                    // console.log(sum, num, ave)
                                    // dataset.data.push(
                                    //     {
                                    //         x: dayHistory.date,
                                    //         y: (ave - measureItem.body.min) / (measureItem.body.max - measureItem.body.min),
                                    //         additionalData: {
                                    //             dateTime: dayHistory.date,
                                    //             value: ave,
                                    //             min: measureItem.body.min,
                                    //             max: measureItem.body.max
                                    //         }
                                    //     }
                                    // )
                                    // 毎00分
                                    for (var i=0; i<dayHistory.values.length; i++) {
                                        const value = dayHistory.values[i]
                                        if (value.time.split(":")[1] == "00") {
                                            const x = dayHistory.date + " " + value.time
                                            const y = value.value // (value.value - measureItem.body.min) / (measureItem.body.max - measureItem.body.min)
                                            dataset.data.push(
                                                {
                                                    x: x,
                                                    y: y,
                                                    additionalData: {
                                                        type: "measure_value",
                                                        dateTime: x,
                                                        value: value.value,
                                                        min: measureItem.body.min,
                                                        max: measureItem.body.max
                                                    }
                                                }
                                            )
                                            // console.log(dataset.data.length, x, y)
                                        }
                                    }
                                }
                            }
                            break;
                        case "day":
                            /** 表示範囲=日 */
                            const dateValues = self.condition.date.split("-")
                            dailyHistories = measureItem.histories[dateValues[0] + "-" + dateValues[1]]
                            dayHistory = dailyHistories[dateValues[2] * 1]
                            if (dayHistory != null) {
                                for (var i=0; i<dayHistory.values.length; i++) {
                                    const value = dayHistory.values[i]
                                    const x = dayHistory.date + " " + value.time
                                    const y = value.value // (value.value - measureItem.body.min) / (measureItem.body.max - measureItem.body.min)
                                    dataset.data.push(
                                        {
                                            x: x,
                                            y: y,
                                            additionalData: {
                                                type: "measure_value",
                                                dateTime: x,
                                                value: value.value,
                                                min: measureItem.body.min,
                                                max: measureItem.body.max
                                            }
                                        }
                                    )
                                }
                            }
                            break;
                        case "day_range":
                            /** 表示範囲=日範囲 */
                            var targetDate = new Date(self.condition.dateFrom)
                            var toDate = new Date(self.condition.dateTo)
                            // console.log("day range data set start", targetDate.toFormatString("yyyy-MM-dd"), toDate.toFormatString("yyyy-MM-dd"))
                            while (true) {
                                // console.log("target date", targetDate.getFullYear(), targetDate.getMonth()+1, targetDate.getDate())
                                dailyHistories = measureItem.histories[targetDate.toFormatString("yyyy-MM")]
                                dayHistory = dailyHistories[targetDate.getDate()]
                                if (dayHistory != null) {
                                    for (var i=0; i<dayHistory.values.length; i++) {
                                        const value = dayHistory.values[i]
                                        const x = dayHistory.date + " " + value.time
                                        const y = value.value // (value.value - measureItem.body.min) / (measureItem.body.max - measureItem.body.min)
                                        // console.log(x, y)
                                        dataset.data.push(
                                            {
                                                x: x,
                                                y: y,
                                                additionalData: {
                                                    type: "measure_value",
                                                    dateTime: x,
                                                    value: value.value,
                                                    min: measureItem.body.min,
                                                    max: measureItem.body.max
                                                }
                                            }
                                        )
                                    }
                                }
                                if (targetDate.getFullYear() == toDate.getFullYear() && targetDate.getMonth() == toDate.getMonth() && targetDate.getDate() == toDate.getDate()) {
                                    break
                                } else {
                                    targetDate.addDay(1)
                                }
                            }
                            break;
                    }
                }

                /**
                 * データセット初期化
                 */
                this.data.datasets = []
                
                /**
                 * 測定データのセット
                 */
                /** データの年月範囲 */
                var conditionYearMonthFrom = null
                var conditionYearMonthTo = null

                switch (this.condition.range) {
                    case "month":
                        const targetYearMonth = new Date(this.condition.year, this.condition.month - 1, 1)
                        conditionYearMonthFrom = new Date(targetYearMonth.toFormatString("yyyy-MM-01"))
                        conditionYearMonthTo = new Date(targetYearMonth.toFormatString("yyyy-MM-01"))
                        break;
                    case "day":
                        const targetDate = new Date(this.condition.date)
                        conditionYearMonthFrom = new Date(targetDate.toFormatString("yyyy-MM-01"))
                        conditionYearMonthTo = new Date(targetDate.toFormatString("yyyy-MM-01"))
                        break;
                    case "day_range":
                        const targetDateFrom = new Date(this.condition.dateFrom)
                        const targetDateTo = new Date(this.condition.dateTo)
                        conditionYearMonthFrom = new Date(targetDateFrom.toFormatString("yyyy-MM-01"))
                        conditionYearMonthTo = new Date(targetDateTo.toFormatString("yyyy-MM-01"))
                        break;
                }
                
                // console.log("condition", conditionYearMonthFrom, conditionYearMonthTo)

                /** 範囲内の月毎に処理 */ 
                var targetYear = conditionYearMonthFrom.getFullYear()
                var targetMonth = conditionYearMonthFrom.getMonth() + 1
                var toYear = conditionYearMonthTo.getFullYear()
                var toMonth = conditionYearMonthTo.getMonth() + 1
                const datasetByMeasureItem = {}

                console.log(this.data)
                
                while (true) {

                    const yearMonth = targetYear + "-" + ("0" + targetMonth).slice(-2)

                    // console.log("データ取得処理対象年月", yearMonth)

                    /** 測定項目毎にデータセットを作成して、測定データをセット */
                    for (var itemIndex=0; itemIndex < this.measureItems.length; itemIndex++) {

                        const measureItem = this.measureItems[itemIndex]

                        if (!measureItem.isVisible) {
                            continue
                        }

                        if (measureItem.body.measureItemID != 0) {  // measureItemID == 0 は、"新しい測定項目" なので、それ以外を処理
                            var dataset = null
                            if (datasetByMeasureItem[measureItem.body.measureItemID] == null) {
                                dataset = {
                                    label: measureItem.body.name,
                                    data: [],
                                    borderColor: self.selectedMeasureItem != null && measureItem.body.measureItemID == self.selectedMeasureItem.body.measureItemID ? "rgba(255,0,0,0.7)" : "rgba(0,0,0,0.7)",
                                    fill: false,
                                    type: "line",
                                    lineTension: 0.0,
                                    borderWidth: self.selectedMeasureItem != null && measureItem.body.measureItemID == self.selectedMeasureItem.body.measureItemID ? 2 : 1,
                                    pointRadius: self.condition.range == "day" ? 0 : 0,
                                    additionalData: {
                                        type: "measure_dataset",
                                        measureItem: measureItem
                                    },
                                    yAxisID: measureItem.viewAxis==1 ? 'y-1' : 'y-2'
                                }
                                self.data.datasets.push(dataset)
                            } else {
                                dataset = datasetByMeasureItem[measureItem.body.measureItemID]
                            }

                            console.log(dataset)

                            if (measureItem.histories[yearMonth] == null) {
                                /** 対象月の測定データを取得していない時は、データベースから取得した後にチャート表示 */
                                // console.log("[[[[ measure data get from DB ]]]]")
                                measureItem.histories[yearMonth] = {}

                                var ref = null
                                if (!measureItem.body.auto) {
                                    ref = db.collection("users").doc(self.userUID)
                                            .collection("places").doc(measureItem.body.placeID+"")
                                            .collection("environments").doc(measureItem.body.measureItemID+"")
                                            .collection("histories")
                                } else {
                                    ref = db.collection("environments").doc(measureItem.body.autoSetting.boxIdentificationCode)
                                            .collection("sensors").doc(measureItem.body.autoSetting.sensorKey)
                                            .collection("records")
                                }
                                await ref.where("date", ">=", yearMonth + "-01")
                                .where("date","<=", yearMonth + "-31")
                                .orderBy("date", "asc")
                                .get().then(function(snapShot){
                                    // console.log("データ件数", snapShot.size)
                                    if (snapShot.size > 0) {
                                        var setNum = 0
                                        snapShot.forEach(function(doc){
                                            const dayValue = doc.data()
                                            const d = new Date(dayValue.date)
                                            measureItem.histories[yearMonth][d.getDate()] = dayValue
                                            setNum++
                                            if (setNum == snapShot.size) {
                                                measureValueSetter(dataset, measureItem)
                                                self.renderChart(self.data, self.options)
                                                // console.log(dataset)
                                            }
                                        })
                                    } else {
                                        self.renderChart(self.data, self.options)
                                    }
                                })

                            } else {
                                /** 既に対象月の測定データを取得している時は、それでチャート表示 */
                                // console.log("[[[[ measure data get from Buffer ]]]]")
                                measureValueSetter(dataset, measureItem)
                            }
                        }
                    }

                    if (targetYear == toYear && targetMonth == toMonth) {
                        break
                    } else {
                        if (targetMonth == 12) {
                            targetYear++
                            targetMonth = 1
                        } else {
                            targetMonth ++
                        }
                    }
                }

                /**
                 * 作業(月表示のみ)
                 */
                // switch (this.condition.range) {
                //     case "month":
                //         const datasetByDay = {}

                //         // console.log("work set start", "work num", this.place.works.length)

                //         for (var i=0; i<this.place.works.length; i++) {
                //             const work = this.place.works[i]
                //             if (work.records != null && work.records.length > 0) {
                //                 // console.log("work", work.name)
                //                 var lastRecordDate = ""
                //                 for (var j=0; j<work.records.length; j++) {
                //                     const record = work.records[j]
                //                     if (lastRecordDate == "" || lastRecordDate != record.date) {
                //                         var datasetWork = null
                //                         if (datasetByDay[record.date] != null) {
                //                             datasetWork = datasetByDay[record.date]
                //                             datasetWork.data[1].additionalData.works.push(work)
                //                         } else {
                //                             datasetWork = {
                //                                 data: [],
                //                                 borderColor: "rgba(0,0,255,0.0)",
                //                                 fill: true,
                //                                 type: "line",
                //                                 borderWidth: 2,
                //                                 pointRadius: 0,
                //                                 lineTension: 0,
                //                                 yAxisID: 'y-1',
                //                                 additionalData: {
                //                                     type: "work_dataset"
                //                                 }
                //                             }
                //                             self.data.datasets.push(datasetWork)
                //                             datasetByDay[record.date] = datasetWork
                //                             datasetWork.data.push(
                //                                 {                                            
                //                                     x: record.date + " 12:00",
                //                                     y: Number.max,
                //                                     additionalData: {
                //                                         type: "work_start"
                //                                     }
                //                                 }
                //                             )
                //                             datasetWork.data.push(
                //                                 {
                //                                     x: record.date + " 12:00",
                //                                     y: y1min,
                //                                     additionalData: {
                //                                         type: "work",
                //                                         works: [work]
                //                                     }
                //                                 }
                //                             )
                //                             datasetWork.data.push(
                //                                 {
                //                                     x: record.date + " 12:00",
                //                                     y: Number.max,
                //                                     additionalData: {
                //                                         type: "work_end"
                //                                     }
                //                                 }
                //                             )
                //                         }

                //                         lastRecordDate = record.date
                //                     }
                //                 }
                //             } else {
                //                 // console.log("work(not recorded)", work.name)
                //             }
                //         }
                //         // console.log("work set completed")

                //         break;
                // }

                /**
                 * レンダリング
                 */
                this.renderChart(this.data, this.options)

                // console.log("======================= chart refresh completed!!")
            }
        }
    }
</script>
